export default __webpack_public_path__ + "static/media/Icon=Dashboard.200ed70c.svg";